import React from 'react';
import { StyleSheet, css } from 'aphrodite-jss';
import cn from 'classnames';
var styles = StyleSheet.create({
  baseModal: {
    minWidth: 600,
    background: 'white',
    borderRadius: 2,
    padding: 32,
    position: 'relative'
  },
  close: {
    position: 'absolute',
    top: 16,
    right: 16,
    color: 'rgba(0, 0, 0, 0.5)',
    cursor: 'pointer',
    '&:hover': {
      color: 'rgba(0, 0, 0, 0.8)'
    }
  }
});

var BaseModal = function BaseModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeIcon = _ref.closeIcon,
      onClickClose = _ref.onClickClose;
  return React.createElement("div", {
    className: cn(css(styles.baseModal), className)
  }, React.createElement("div", {
    className: css(styles.close),
    onClick: onClickClose
  }, closeIcon ? closeIcon : '✕'), children);
};

export default BaseModal;